import { Injectable, ElementRef, Renderer2, ViewChild, RendererFactory2 } from '@angular/core';
import { POINTER_EVENTS_SUPPORTED } from '../utils/pointer-input.utils';

/** Глобальное удержание: capture на document; см. `POINTER_EVENTS_SUPPORTED` и комментарий в `pointer-input.utils.ts`. */
@Injectable()
export class KeyStateService {
  result = {
    isMouseHold: false,
    ctrlHold: false
  };

  @ViewChild('rendererContainer') rendererContainer: ElementRef;
  private renderer: Renderer2;
  private activePointerIds = new Set<number>();

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);

    if (POINTER_EVENTS_SUPPORTED && typeof document !== 'undefined') {
      document.addEventListener('pointerdown', this.onPointerDown, true);
      document.addEventListener('pointerup', this.onPointerUp, true);
      document.addEventListener('pointercancel', this.onPointerUp, true);
    } else if (typeof document !== 'undefined') {
      document.addEventListener('mousedown', this.mouseDown.bind(this), true);
      document.addEventListener('mouseup', this.mouseUp.bind(this), true);
    }

    this.renderer.listen('body', 'dblclick', this.dblclick.bind(this));
    this.renderer.listen('body', 'keydown', this.onKeyPress.bind(this));
    this.renderer.listen('body', 'keyup', this.onKeyPress.bind(this));
  }

  private syncHold() {
    this.result.isMouseHold = this.activePointerIds.size > 0;
  }

  private onPointerDown = (e: PointerEvent) => {
    if (typeof e.pointerId === 'number') {
      this.activePointerIds.add(e.pointerId);
      this.syncHold();
    }
  };

  private onPointerUp = (e: PointerEvent) => {
    if (typeof e.pointerId === 'number') {
      this.activePointerIds.delete(e.pointerId);
      this.syncHold();
    }
  };

  mouseDown(e) {
    this.result.isMouseHold = true;
  }

  mouseUp(e) {
    this.result.isMouseHold = false;
  }

  dblclick(e) {
    this.result.isMouseHold = false;
  }

  onKeyPress(e) {
    this.result.ctrlHold = e.ctrlKey;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/key-state.service.ts